import { initSentry } from '@/lib/sentry';

// Initialize Sentry before React renders
initSentry();

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './globals.css';

// Debug: Log when app mounts to distinguish true reloads from perceived flash
// If this logs on every navigation, it's a true reload; if not, it's Suspense/CSS flash
console.log('[SPA Debug] App mounted at:', new Date().toISOString());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
